export default __webpack_public_path__ + "static/banner-renovation-checklist-d7244e26d1e0bc9d3aed520dd5f1a909.jpg";